import axios from "axios";

const url = 'https://api-gestao-rdi.prod.cenix.com.br/api/';
// const url = 'http://127.0.0.1:8000/api/';
const urlMobile = 'https://api-mobile-rdi.prod.cenix.com.br/api/';


const api = axios.create({
    baseURL: url
});


api.interceptors.request.use(async (config: any) => {
    try {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`
        }
        return config;
    } catch (err) {
        // console.log(err);
    }
});

api.interceptors.response.use(function (response) {
    // Qualquer código de status que dentro do limite de 2xx faz com que está função seja acionada
    // Faz alguma coisa com os dados de resposta
    return response;
}, function (error) {
    // Qualquer código de status que não esteja no limite do código 2xx faz com que está função seja acionada
    // Faz alguma coisa com o erro da resposta

    if (error.response.status === 401 && error.response.data.message !== 'Usuário e/ou senha incorretos!') {
        window.location.href = '/';
    }

    return Promise.reject(error);
});


export { api, url, urlMobile };
